var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('label',[_vm._v(_vm._s(_vm.element.label))]),_c('y-form-select',{attrs:{"options":_vm.options,"value":_vm.model,"is-loading":false,"disabled":_vm.element.disabled},on:{"input":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }